module.exports = __webpack_public_path__ + "static/img/kjdy5.ec427c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy5.png
// module id = 340
// module chunks = 0